import logotipo from "../../components/LandingPages/assets/imagens/svg/logotipo.svg"
import imgEbook from "../../components/LandingPages/assets/imagens/webp/ebook.webp"
import HeroBanner from "../../components/LandingPages/tempalates-parts/Ebook/index.tsx";
import Footer from "../../components/LandingPages/tempalates-parts/Footer";

function TemplateLandingPageTecnologia() {

  (function (w, d, s, l, i) {
    w[l] = w[l] || []; w[l].push({
      'gtm.start':
        new Date().getTime(), event: 'gtm.js'
    }); var f = d.getElementsByTagName(s)[0],
      j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src =
        'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);
  })(window, document, 'script', 'dataLayer', 'GTM-MM72KNL2');

  return (
    <>
      <noscript>
        <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-MM72KNL2"
          height="0" width="0" style="display:none;visibility:hidden"></iframe>
      </noscript>
      <HeroBanner
        logoSrc={logotipo}
        logoAlt="Meu Contador Online"
        title="DESCUBRA AS PENDÊNCIAS FISCAIS DO SEU CNPJ INAPTO EM MINUTOS!"
        highlightWord="CNPJ INAPTO"
        subtitle="Baixe o guia prático gratuito com o passo a passo para identificar obrigações atrasadas na Receita Federal e poder regularizar seu CNPJ."
        ctaText="Quero baixar o guia gratuito"
        ctaHref="#download"
        badgeText="O processo leva menos de 5 minutos!"
        imageSrc={imgEbook}
        imageAlt="E-book Passo a passo para regularizar seu CNPJ inapto"
      />

      {/**<Footer /> */}
    </>
  );
}
export default TemplateLandingPageTecnologia;
